/**
 * Feature Flags Configuration
 * Control feature availability and cost optimization settings
 */

export const FEATURE_FLAGS = {
  // Presence System - DISABLED to save costs ($100+/month)
  ENABLE_PRESENCE: false,
  
  // Chat optimizations
  MAX_ACTIVE_SUBSCRIPTIONS: 10,
  CONVERSATION_LIMIT: 50,
  
  // Notification settings
  BATCH_NOTIFICATIONS: true,
  BATCH_SIZE: 5,
  BATCH_DELAY: 2000,
  
  // Real-time features
  ENABLE_TYPING_INDICATORS: true,
  TYPING_DEBOUNCE_MS: 1000,
  
  // Performance settings
  DEBOUNCE_UPDATES_MS: 500,
  HEARTBEAT_INTERVAL_MS: 60000, // 1 minute
  IDLE_DISCONNECT_MS: 300000, // 5 minutes
};

export default FEATURE_FLAGS;
